// import GitInfo from 'react-git-info/macro'

// const gitInfo = GitInfo()

let confProp
if (process.env.REACT_APP_TARGET === 'production') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restURL: 'https://api.officemail.io',
      URL: 'https://api.officemail.io/graphql',
      wsURL: null,
    },
  }
} else if (process.env.REACT_APP_TARGET === 'test') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restURL: 'https://dev-api.officemail.io',
      URL: 'https://dev-api.officemail.io/graphql',
      wsURL: null,
    },
  }
} else if (process.env.REACT_APP_TARGET === 'test1') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restURL: 'https://dev.api.enterprise.rework.so',
      URL: 'https://dev.api.enterprise.rework.so/graphql',
      wsURL: null,
    },
  }
} else if (process.env.REACT_APP_TARGET === 'log') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restURL: 'https://dev.api.enterprise.rework.so',
      URL: 'https://dev.api.enterprise.rework.so/graphql',
      wsURL: null,
    },
  }
} else {
  confProp = {
    DEBUG: true,
    SERVER: {
      restURL: 'https://dev.api.enterprise.rework.so',
      URL: 'https://dev.api.enterprise.rework.so/graphql',
      wsURL: null,
    },
  }
}

confProp.defaultLocale = 'en-US' // 'ko-KR'

if (window.globalConfig != null) {
  if (window.globalConfig.JMAP_URL != null) {
    confProp.SERVER.JMAP_URL = window.globalConfig.JMAP_URL
  }
  if (window.globalConfig.wsURL != null) {
    confProp.SERVER.wsURL = window.globalConfig.wsURL
  }
  if (window.globalConfig.LOCALE != null) {
    confProp.defaultLocale = window.globalConfig.LOCALE
  }
}

// confProp.gitInfo = gitInfo

const conf = confProp

export default conf
